<template>
  <div>
    <b-table
      :class="tableClass"
      :data="tablaAmortizacion"
      height="auto"
      class="has-text-white has-border-radius mt-4 tabla-amortizacion w-full"
    >
      <b-table-column field="numero_pago" label="#" v-slot="props">
        {{ soloSaldos ? props.index + 1 : props.index }}
      </b-table-column>
      <b-table-column field="fechaDePago" label="Fecha" v-slot="props">
        {{ props.row.fechaDePago | moment("DD-MM-YYYY") }}
      </b-table-column>
      <b-table-column v-if="!arrendamiento" field="diasPorPeriodo" label="Días de calculo" v-slot="props">
        {{ props.row.diasPorPeriodo }}
      </b-table-column>
      <b-table-column
        field="capitalInsoluto"
        label="Capital insoluto"
        numeric
        v-slot="props"
      >
        {{ props.row.capitalInsoluto | currency | hp }}
      </b-table-column>
      <b-table-column field="tasa" label="Tasa" numeric v-slot="props">
        {{ Math.round(((props.row.tasaBase * 100) + Number.EPSILON) * 100) / 100 }}%
      </b-table-column>
      <b-table-column field="tasa" label="Tipo tasa">
        <div class="is-size-7">{{ tasaBase }}</div>
      </b-table-column>
      <b-table-column
        field="interesCalculado"
        label="Interés calculado"
        numeric
        v-slot="props"
      >
        {{ props.row.interesCalculado | currency | hp }}
        <p v-if="props.index == tablaAmortizacion.length - 1" class="mt-3 font-medium">
          Totales:
        </p>
      </b-table-column>
      <b-table-column
        v-if="!sinIvaCapitalizado"
        field="interesCapitalizado"
        label="Interés capitalizado"
        numeric
        v-slot="props"
      >
        {{ props.row.interesCapitalizado | currency | hp }}
      </b-table-column>
      <b-table-column field="capital" label="Capital" numeric v-slot="props">
        {{ props.row.capitalPagoDelPeriodo | currency | hp }}
        <p v-if="props.index == tablaAmortizacion.length - 1" class="mt-3 font-medium">
          {{ tablaAmortizacion[0].capitalInsoluto | currency | hp }}
        </p>
      </b-table-column>
      <b-table-column
        label="IVA Capital"
        field="ivaCapitalPagoDelPeriodo"
        numeric
        v-slot="props"
      >
        {{ props.row.ivaCapitalPagoDelPeriodo | currency | hp }}
        <p v-if="props.index == tablaAmortizacion.length - 1" class="mt-3 font-medium">
          {{ getSumaColumna('ivaCapitalPagoDelPeriodo') | currency | hp }}
        </p>
      </b-table-column>
      <b-table-column
        field="interesPagoDelPeriodo"
        label="Interés"
        numeric
        v-slot="props"
      >
        {{ props.row.interesPagoDelPeriodo | currency | hp }}
        <p v-if="props.index == tablaAmortizacion.length - 1" class="mt-3 font-medium">
          {{ getSumaColumna('interesPagoDelPeriodo') | currency | hp }}
        </p>
      </b-table-column>
      <b-table-column
        field="ivaInteresPagoDelPeriodo"
        label="IVA Interés"
        numeric
        v-slot="props"
      >
        {{ props.row.ivaInteresPagoDelPeriodo | currency | hp }}
        <p v-if="props.index == tablaAmortizacion.length - 1" class="mt-3 font-medium">
          {{ getSumaColumna('ivaInteresPagoDelPeriodo') | currency | hp }}
        </p>
      </b-table-column>
      <b-table-column
        field="pagoTotal"
        label="Pago Total"
        numeric
        v-slot="props"
      >
        {{ props.row.pagoTotal | currency | hp }}
        <p v-if="props.index == tablaAmortizacion.length - 1" class="mt-3 font-medium">
          {{
            tablaAmortizacion[0].capitalInsoluto + 
            getSumaColumna('ivaCapitalPagoDelPeriodo') +
            getSumaColumna('interesPagoDelPeriodo') +
            getSumaColumna('ivaInteresPagoDelPeriodo') | currency | hp 
          }}
        </p>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "TablaAmortizaciones",
  props: {
    tablaAmortizacion: Array,
    tableClass: String,
    tasaBase: String,
    sinIvaCapitalizado: Boolean,
    arrendamiento: Boolean,
    soloSaldos: Boolean,
  },
  methods: {
    getSumaColumna(columna) {
      const suma = this.tablaAmortizacion.reduce((acc, curr) => {
        if (curr[columna]) return acc += parseFloat(curr[columna]);

        return acc;
      }, 0);

      return Math.round((suma + Number.EPSILON) * 100) / 100;
    }
  }
};
</script>
